/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
    width: inherit;
    height: auto;
    .fill {
        fill: transparent;
    }
`

export default class FavoriteBorderIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="14.204" height="13.68" viewBox="0 0 14.204 13.68" css={Color} className="favorite-border-icon">
        <path className="fill" id="favoriteManage" d="M137.594,176.917a.949.949,0,0,0-.49-.133.925.925,0,0,0-.477.133,1.028,1.028,0,0,0-.331.371l-1.377,2.8a.324.324,0,0,1-.119.146.588.588,0,0,1-.185.08l-3.072.437a.9.9,0,0,0-.463.212.835.835,0,0,0-.278.411.89.89,0,0,0-.013.5.95.95,0,0,0,.252.437l2.225,2.16a.469.469,0,0,1,.093.172.27.27,0,0,1,.013.185l-.516,3.061a.97.97,0,0,0,.053.5.9.9,0,0,0,.3.4,1,1,0,0,0,.477.172.966.966,0,0,0,.49-.106l2.741-1.444a.37.37,0,0,1,.185-.053.326.326,0,0,1,.185.053l2.754,1.444a.887.887,0,0,0,.424.106.942.942,0,0,0,.543-.172.9.9,0,0,0,.3-.4.97.97,0,0,0,.053-.5l-.53-3.061a.441.441,0,0,1,.013-.185.7.7,0,0,1,.106-.172l2.224-2.16a.951.951,0,0,0,.252-.437.821.821,0,0,0-.027-.5.835.835,0,0,0-.278-.411.887.887,0,0,0-.45-.212l-3.072-.437a.588.588,0,0,1-.185-.08.324.324,0,0,1-.119-.146l-1.377-2.8a1.027,1.027,0,0,0-.331-.371" transform="translate(-130.007 -176.034)" fill="none" stroke="#6f777e" strokeWidth="1.5"/>
      </svg>
    )
  }
}
